import { me } from './selectors.js';
import { S, UI } from './store.js';
import { uid } from './util.js';

export function act(pid,who,text){S.activity.unshift({id:uid(),pid,who,text,t:Date.now()});S.activity=S.activity.slice(0,60)}

export const actor=()=>UI.cv?'Client':me().name;

// Who did what, shown to the directors in the Boardroom and used for account changes.
export const audit=(text)=>{S.audit.unshift({who:me().name,text,t:Date.now()});S.audit=S.audit.slice(0,40)};
